import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getReportDeviceMounts: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REPORT_DEVICE_MOUNTS].GET_REPORT_DEVICE_MOUNTS,
	},
	getReportDeviceMount: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REPORT_DEVICE_MOUNTS].GET_REPORT_DEVICE_MOUNT,
	},
}
